import HourlyEntries from "./HourlyEntries";

export default HourlyEntries;